import * as React from "react";

interface Props {
    /**
     * The text that should appear above the loading bar.
     * @default "Loading."
     */
    text?: string
}

export function LoadingSpinner(props: Props): JSX.Element {
    return (
        <div className="loading-spinner">
            <label>
                {props.text ?? "Loading."}
                <progress />
            </label>
        </div>
    )
}
